export class Metagroup {
  id?: string;
  label?: string;
  application?: string;
  organization?: string;
  description?: string;
  constructor() {}
}
